function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var ModTemplate = require('../../lib/templates/modtemplate');
var SaitoHeader = require('../../lib/saito/ui/saito-header/saito-header');
var PeerService = require('saito-js/lib/peer_service')["default"];
var Main = require('./lib/ui/main');
var Warehouse = require('./lib/warehouse');
var transactions = require('./lib/transactions');
var _require = require('./lib/images'),
  serveCachedImageResponse = _require.serveCachedImageResponse;
var _require2 = require('./lib/categories'),
  normalizeOffset = _require2.normalizeOffset,
  normalizePageSize = _require2.normalizePageSize,
  mapNFTTypeToCategory = _require2.mapNFTTypeToCategory,
  categoryViewKey = _require2.categoryViewKey;
var index = require('./index');
var StoreWithdrawals = require('./lib/withdrawal');
var StoreAdmin = require('./lib/admin/store-admin');
var Store = /*#__PURE__*/function (_ModTemplate) {
  function Store(app) {
    var _this;
    _classCallCheck(this, Store);
    _this = _callSuper(this, Store, [app]);
    _this.name = 'Store';
    _this.slug = 'store';
    _this.description = 'A marketplace for digital and phyisical goods. The Saito store showcases the best of the community. Everyone has a store, as soon as they list anitem for sale!';
    _this.status = 'beta';
    _this["class"] = 'utility';
    _this.dbname = 'store';
    _this.shortlinks_enabled = 1;
    _this.social = _this.buildSocial({
      twitter: '@SaitoOfficial',
      title: 'Saito Store',
      description: _this.description,
      url: '/store',
      image: '/store/img/store.png'
    });
    _this.styles = ['/store/style.css', '/saito/lib/jsonTree/jsonTree.css'];
    _this.main = null;
    _this.header = null;
    _this.summaries = {};
    _this.image_cache = {};
    _this.store_public_key = '';
    // Treasury keys that may issue a web3 purchase. The server's own public key
    // is added when a purchase is checked, so this node can issue those payments.
    _this.web3_payment_processor_publickey = ['cNACSaLdZQfbPkTTud4ezLWFYqRPUCMEt2dgLxJ9Axxx'];
    _this.store_peer_index = null;
    _this.shared_listing_path = '';
    _this.listings_to_moderate = 0;
    _this.fee = 0;
    _this.order_retry_limit = 10;
    // How long the same saved refund may be rebroadcast. Expiry stops retries.
    // It does not authorize another signed refund.
    _this.refund_retry_ms = 6 * 60 * 60 * 1000;
    // Longest-chain blocks searched for a settlement whose order update was missed.
    _this.fulfillment_reconcile_blocks = 512;
    // Saito blocks after a web3 sale's inclusion before those proceeds are eligible.
    _this.web3_withdrawal_blocks = 5;
    // User-store chrome is read-only; edits stay on Profile / Red Square hosts.
    _this.enable_profile_edits = false;
    _this.warehouse = new Warehouse(app, _this);
    _this.withdrawals = new StoreWithdrawals(_this);
    Object.assign(_this, transactions);
    return _this;
  }
  _inherits(Store, _ModTemplate);
  return _createClass(Store, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        var _this2 = this;
        var SaitoTransactionMonitor, PurchaseMonitor, DelistOverlay, _this$app$modules$ret, _this$app$modules, cm;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _superPropGet(Store, "initialize", this, 3)([app]);
            case 1:
              if (this.app.BROWSER) {
                _context.n = 2;
                break;
              }
              this.store_public_key = this.publicKey;
              _context.n = 2;
              return this.warehouse.initialize();
            case 2:
              if (this.app.BROWSER) {
                SaitoTransactionMonitor = require('../../lib/saito/ui/saito-transaction-monitor/saito-transaction-monitor');
                PurchaseMonitor = require('./lib/ui/overlays/purchase-monitor');
                this.transaction_monitor = new SaitoTransactionMonitor(this.app, this);
                this.purchase_monitor = new PurchaseMonitor(this.app, this);
                DelistOverlay = require('./lib/ui/overlays/delist-overlay');
                this.delist_overlay = new DelistOverlay(this.app, this);

                // TEMP: prove store-nft-rental arrives self-contained with Vault fields.
                this._store_rental_receipt_alerts = new Set();
                this.app.connection.on('on-nft-received', function (payload) {
                  void _this2.alertStoreRentalReceipt(payload);
                });
                this.app.connection.on('store-listing-lifecycle', function (entry) {
                  if ((entry === null || entry === void 0 ? void 0 : entry.phase) === 'complete') {
                    void _this2.maybePublishStoreProfileLink(entry);
                  }
                });
              }
              if (!this.browser_active) {
                _context.n = 5;
                break;
              }
              this.header = new SaitoHeader(this.app, this);
              _context.n = 3;
              return this.header.initialize(this.app);
            case 3:
              this.addComponent(this.header);
              this.main = new Main(this.app, this);
              _context.n = 4;
              return this.main.initialize();
            case 4:
              this.addComponent(this.main);

              // Chat is optional: wake ChatManager for popups only (no sidebar list).
              cm = (_this$app$modules$ret = (_this$app$modules = this.app.modules).returnFirstRespondTo) === null || _this$app$modules$ret === void 0 ? void 0 : _this$app$modules$ret.call(_this$app$modules, 'chat-manager');
              if (cm) {
                cm.render_popups_to_screen = 1;
                cm.render_manager_to_screen = 0;
              }
            case 5:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
    /**
     * Ask Profile (if installed) to set or clear the preferred storefront URL.
     * Blank address removes the Profile `store` field. No-op when Profile is absent.
     */
  }, {
    key: "updateProfile",
    value: function () {
      var _updateProfile = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var address,
          api,
          store,
          _args2 = arguments;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              address = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : '';
              if (this.app.BROWSER) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              api = this.app.modules.returnFirstRespondTo('profile-update');
              if (!(!api || typeof api.update !== 'function')) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              store = address == null ? '' : String(address).trim();
              _context2.n = 3;
              return api.update({
                store: store
              });
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function updateProfile() {
        return _updateProfile.apply(this, arguments);
      }
      return updateProfile;
    }()
    /**
     * TEMP debug: when a store-nft-rental arrives from another party, load the
     * received NFT txmsg and alert Vault/rental fields. One alert per nft_id.
     */
  }, {
    key: "alertStoreRentalReceipt",
    value: function () {
      var _alertStoreRentalReceipt = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var payload,
          nft_id,
          slip3,
          slip_type,
          _this$app$options,
          _nft$tx,
          _nft$tx$returnMessage,
          _data$link,
          _data$nft_type,
          _data$filename,
          _data$file_id,
          _data$file_access_scr,
          rec,
          SaitoNFT,
          nft,
          data,
          _args3 = arguments,
          _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              payload = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
              if (this.app.BROWSER) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              nft_id = String((payload === null || payload === void 0 ? void 0 : payload.nft_id) || (payload === null || payload === void 0 ? void 0 : payload.id) || '').trim();
              slip3 = String((payload === null || payload === void 0 ? void 0 : payload.slip3_utxo) || '').trim();
              if (!(!nft_id || !slip3)) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2);
            case 2:
              slip_type = this.app.wallet.extractNFTType(slip3);
              if (!(slip_type !== 'store-nft-rental')) {
                _context3.n = 3;
                break;
              }
              return _context3.a(2);
            case 3:
              if (!(payload !== null && payload !== void 0 && payload.sender && payload.sender === this.publicKey)) {
                _context3.n = 4;
                break;
              }
              return _context3.a(2);
            case 4:
              if (!this._store_rental_receipt_alerts.has(nft_id)) {
                _context3.n = 5;
                break;
              }
              return _context3.a(2);
            case 5:
              this._store_rental_receipt_alerts.add(nft_id);
              _context3.p = 6;
              _context3.n = 7;
              return this.app.wallet.updateNFTList();
            case 7:
              rec = (((_this$app$options = this.app.options) === null || _this$app$options === void 0 || (_this$app$options = _this$app$options.wallet) === null || _this$app$options === void 0 ? void 0 : _this$app$options.nfts) || []).find(function (row) {
                return String((row === null || row === void 0 ? void 0 : row.id) || '') === nft_id;
              });
              if (rec) {
                _context3.n = 8;
                break;
              }
              return _context3.a(2);
            case 8:
              SaitoNFT = require('../../lib/saito/ui/saito-nft/saito-nft');
              nft = new SaitoNFT(this.app, this, null, rec);
              if (!(typeof nft.fetchTransaction === 'function')) {
                _context3.n = 9;
                break;
              }
              _context3.n = 9;
              return new Promise(function (resolve) {
                var settled = false;
                var finish = function finish() {
                  if (!settled) {
                    settled = true;
                    resolve();
                  }
                };
                nft.fetchTransaction(finish);
                setTimeout(finish, 8000);
              });
            case 9:
              if (typeof nft.buildNFTData === 'function' && nft.tx) {
                nft.buildNFTData(nft.tx);
              }
              data = ((_nft$tx = nft.tx) === null || _nft$tx === void 0 || (_nft$tx$returnMessage = _nft$tx.returnMessage) === null || _nft$tx$returnMessage === void 0 || (_nft$tx$returnMessage = _nft$tx$returnMessage.call(_nft$tx)) === null || _nft$tx$returnMessage === void 0 ? void 0 : _nft$tx$returnMessage.data) || nft.data || {};
              alert(['TEMP store-nft-rental receipt', "link: ".concat((_data$link = data.link) !== null && _data$link !== void 0 ? _data$link : ''), "nft_type: ".concat((_data$nft_type = data.nft_type) !== null && _data$nft_type !== void 0 ? _data$nft_type : ''), "filename: ".concat((_data$filename = data.filename) !== null && _data$filename !== void 0 ? _data$filename : ''), "file_id: ".concat((_data$file_id = data.file_id) !== null && _data$file_id !== void 0 ? _data$file_id : ''), "file_access_script: ".concat(typeof data.file_access_script === 'string' ? data.file_access_script : JSON.stringify((_data$file_access_scr = data.file_access_script) !== null && _data$file_access_scr !== void 0 ? _data$file_access_scr : ''))].join('\n'));
              _context3.n = 11;
              break;
            case 10:
              _context3.p = 10;
              _t = _context3.v;
              console.warn('Store: rental receipt alert failed', (_t === null || _t === void 0 ? void 0 : _t.message) || _t);
            case 11:
              return _context3.a(2);
          }
        }, _callee3, this, [[6, 10]]);
      }));
      function alertStoreRentalReceipt() {
        return _alertStoreRentalReceipt.apply(this, arguments);
      }
      return alertStoreRentalReceipt;
    }()
    /**
     * Current Profile `store` field via optional profile-update capability.
     */
  }, {
    key: "returnProfileStoreUrl",
    value: function returnProfileStoreUrl() {
      var _this$app$modules$ret2, _this$app$modules2;
      var api = (_this$app$modules$ret2 = (_this$app$modules2 = this.app.modules).returnFirstRespondTo) === null || _this$app$modules$ret2 === void 0 ? void 0 : _this$app$modules$ret2.call(_this$app$modules2, 'profile-update');
      if (!api || typeof api.get !== 'function') {
        return '';
      }
      try {
        var profile = api.get() || {};
        return String(profile.store || '').trim();
      } catch (err) {
        return '';
      }
    }

    /**
     * After the seller's first successful listing, publish the storefront URL to Profile.
     * Later listings no-op (Profile already has the URL, or inventory count > 1 after uncheck).
     */
  }, {
    key: "maybePublishStoreProfileLink",
    value: function () {
      var _maybePublishStoreProfileLink = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var entry,
          url,
          _ref,
          _result$pagination$to,
          _result$pagination,
          _result$listings,
          _require3,
          loadListingsPage,
          result,
          total,
          _args4 = arguments,
          _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              entry = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
              if (!(!this.app.BROWSER || !this.publicKey)) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              if (!(entry.seller && entry.seller !== this.publicKey)) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2);
            case 2:
              url = this.returnStorefrontUrl(this.publicKey);
              if (url) {
                _context4.n = 3;
                break;
              }
              return _context4.a(2);
            case 3:
              if (!(this.returnProfileStoreUrl() === url)) {
                _context4.n = 4;
                break;
              }
              return _context4.a(2);
            case 4:
              _context4.p = 4;
              _require3 = require('./lib/ui/browse-listings'), loadListingsPage = _require3.loadListingsPage;
              _context4.n = 5;
              return loadListingsPage(this.app, this, {
                public_key: this.publicKey,
                category: '',
                offset: 0,
                page_size: 1
              });
            case 5:
              result = _context4.v;
              total = Number((_ref = (_result$pagination$to = result === null || result === void 0 || (_result$pagination = result.pagination) === null || _result$pagination === void 0 ? void 0 : _result$pagination.total) !== null && _result$pagination$to !== void 0 ? _result$pagination$to : result === null || result === void 0 || (_result$listings = result.listings) === null || _result$listings === void 0 ? void 0 : _result$listings.length) !== null && _ref !== void 0 ? _ref : 0);
              if (!(total !== 1)) {
                _context4.n = 6;
                break;
              }
              return _context4.a(2);
            case 6:
              _context4.n = 7;
              return this.updateProfile(url);
            case 7:
              this.app.connection.emit('store-profile-link-updated');
              _context4.n = 9;
              break;
            case 8:
              _context4.p = 8;
              _t2 = _context4.v;
              console.warn('Store: profile store link publish skipped', (_t2 === null || _t2 === void 0 ? void 0 : _t2.message) || _t2);
            case 9:
              return _context4.a(2);
          }
        }, _callee4, this, [[4, 8]]);
      }));
      function maybePublishStoreProfileLink() {
        return _maybePublishStoreProfileLink.apply(this, arguments);
      }
      return maybePublishStoreProfileLink;
    }()
  }, {
    key: "returnServices",
    value: function returnServices() {
      var services = [];
      if (!this.app.BROWSER) {
        services.push(new PeerService(null, 'Store', this.publicKey));
      }
      return services;
    }
  }, {
    key: "onPeerServiceUp",
    value: function () {
      var _onPeerServiceUp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(app, peer) {
        var _this$app$options2,
          _this$main,
          _this3 = this;
        var service,
          route,
          listingPath,
          manager,
          _manager$moderate,
          _manager$moderate$rel,
          _args6 = arguments;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              service = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
              if (!(service.service !== 'Store')) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2);
            case 1:
              if (this.app.BROWSER) {
                _context6.n = 2;
                break;
              }
              return _context6.a(2);
            case 2:
              this.store_public_key = peer.publicKey;
              this.store_peer_index = peer.peerIndex;
              console.log('Store: onPeerServiceUp store_public_key=', this.store_public_key);
              if (this.browser_active || Number((_this$app$options2 = this.app.options) === null || _this$app$options2 === void 0 || (_this$app$options2 = _this$app$options2.store) === null || _this$app$options2 === void 0 ? void 0 : _this$app$options2.moderator) === 1) {
                this.requestStoreModerationState();
              }
              if (!(!this.browser_active || !((_this$main = this.main) !== null && _this$main !== void 0 && _this$main.manager))) {
                _context6.n = 3;
                break;
              }
              return _context6.a(2);
            case 3:
              route = this.returnStoreRouteFromPath();
              listingPath = window.location.pathname;
              if ((route.signature || route.nft_id) && this.shared_listing_path !== listingPath) {
                this.shared_listing_path = listingPath;
                app.network.sendRequestAsTransaction('load-listing', {
                  module: this.name,
                  signature: route.signature,
                  seller: route.publicKey,
                  nft_id: route.nft_id
                }, /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(response) {
                    var Summary;
                    return _regenerator().w(function (_context5) {
                      while (1) switch (_context5.n) {
                        case 0:
                          if (!(window.location.pathname !== listingPath)) {
                            _context5.n = 1;
                            break;
                          }
                          return _context5.a(2);
                        case 1:
                          if (response !== null && response !== void 0 && response.listing) {
                            _context5.n = 2;
                            break;
                          }
                          siteMessage((response === null || response === void 0 ? void 0 : response.err) || 'Listing unavailable', 5000);
                          return _context5.a(2);
                        case 2:
                          Summary = require('./lib/summary');
                          _context5.n = 3;
                          return _this3.main.openStorefront(response.listing.seller, {
                            updateUrl: false
                          });
                        case 3:
                          if (!(window.location.pathname !== listingPath)) {
                            _context5.n = 4;
                            break;
                          }
                          return _context5.a(2);
                        case 4:
                          _this3.main.listing_detail.open(new Summary(app, _this3, response.listing));
                        case 5:
                          return _context5.a(2);
                      }
                    }, _callee5);
                  }));
                  return function (_x4) {
                    return _ref2.apply(this, arguments);
                  };
                }(), peer.publicKey);
              }

              // Peer readiness only enables fetch — do not change which Store context is active.
              manager = this.main.manager;
              if (!(manager.activePanel === 'my-listings')) {
                _context6.n = 4;
                break;
              }
              void manager.storefront.reloadInventory();
              return _context6.a(2);
            case 4:
              if (!(manager.activePanel === 'sales')) {
                _context6.n = 5;
                break;
              }
              void manager.sales.show();
              return _context6.a(2);
            case 5:
              if (!(manager.activePanel === 'moderate')) {
                _context6.n = 6;
                break;
              }
              void ((_manager$moderate = manager.moderate) === null || _manager$moderate === void 0 || (_manager$moderate$rel = _manager$moderate.reload) === null || _manager$moderate$rel === void 0 ? void 0 : _manager$moderate$rel.call(_manager$moderate));
              return _context6.a(2);
            case 6:
              void manager.browse.loadPage({
                category: manager.browse.category,
                page: manager.browse.page || 1,
                scroll: false
              });
            case 7:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function onPeerServiceUp(_x2, _x3) {
        return _onPeerServiceUp.apply(this, arguments);
      }
      return onPeerServiceUp;
    }()
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(app) {
        var _txmsg$data;
        var tx,
          peer,
          mycallback,
          txmsg,
          authorized,
          pending,
          data,
          result,
          _pending,
          _data,
          action,
          signatures,
          results,
          _iterator,
          _step,
          signature,
          _result,
          _pending2,
          _data2,
          public_key,
          _result2,
          listings,
          _tx$from,
          seller,
          latestBlockId,
          _this$app$blockchain,
          _this$app$blockchain$,
          balances,
          _tx$from2,
          _seller,
          _data3,
          quote,
          _result3,
          _tx$from3,
          _data4,
          _signature,
          requester,
          row,
          _result4,
          _data5,
          _signature2,
          _action,
          _row,
          approved,
          ok,
          _row2,
          Listing,
          summary,
          _data6,
          _seller2,
          _result5,
          _tx$from4,
          _data7,
          _signature3,
          _requester,
          _row3,
          _Listing,
          listing,
          _args7 = arguments,
          _t3,
          _t4,
          _t5,
          _t6,
          _t7,
          _t8,
          _t9,
          _t0;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              tx = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : null;
              peer = _args7.length > 2 ? _args7[2] : undefined;
              mycallback = _args7.length > 3 && _args7[3] !== undefined ? _args7[3] : null;
              if (!(tx == null)) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2, 0);
            case 1:
              txmsg = tx.returnMessage();
              if (!((txmsg === null || txmsg === void 0 ? void 0 : txmsg.request) === 'store-moderation-response')) {
                _context7.n = 2;
                break;
              }
              if (!this.app.BROWSER) {
                _context7.n = 2;
                break;
              }
              this.applyStoreModerationResponse(txmsg.data && _typeof(txmsg.data) === 'object' ? txmsg.data : txmsg);
              return _context7.a(2, 1);
            case 2:
              if (!((txmsg === null || txmsg === void 0 ? void 0 : txmsg.request) === 'store-moderation')) {
                _context7.n = 5;
                break;
              }
              if (!(!this.app.BROWSER && mycallback != null)) {
                _context7.n = 5;
                break;
              }
              authorized = this.canModerateStore(tx) ? 1 : 0;
              pending = 0;
              if (!authorized) {
                _context7.n = 4;
                break;
              }
              _context7.n = 3;
              return this.warehouse.db.countPendingModerationListings();
            case 3:
              pending = _context7.v;
            case 4:
              mycallback({
                request: 'store-moderation-response',
                authorized: authorized,
                pending: pending
              });
              return _context7.a(2, 1);
            case 5:
              if (!((txmsg === null || txmsg === void 0 ? void 0 : txmsg.request) === 'load-pending-listings')) {
                _context7.n = 9;
                break;
              }
              if (!(!this.app.BROWSER && mycallback != null)) {
                _context7.n = 9;
                break;
              }
              if (this.canModerateStore(tx)) {
                _context7.n = 6;
                break;
              }
              mycallback({
                err: 'Unauthorized access',
                authorized: 0,
                pending: 0,
                listings: []
              });
              return _context7.a(2, 1);
            case 6:
              data = txmsg.data && _typeof(txmsg.data) === 'object' ? txmsg.data : {};
              _context7.n = 7;
              return this.warehouse.returnPendingModerationPage({
                offset: normalizeOffset(data.offset),
                page_size: normalizePageSize(data.page_size),
                sort: data.sort,
                direction: data.direction
              });
            case 7:
              result = _context7.v;
              _context7.n = 8;
              return this.warehouse.db.countPendingModerationListings();
            case 8:
              _pending = _context7.v;
              mycallback({
                authorized: 1,
                pending: _pending,
                listings: result.listings.map(function (summary) {
                  return summary.serialize();
                }),
                sort: result.sort,
                direction: result.direction,
                pagination: result.pagination
              });
              return _context7.a(2, 1);
            case 9:
              if (!((txmsg === null || txmsg === void 0 ? void 0 : txmsg.request) === 'moderate-listings')) {
                _context7.n = 21;
                break;
              }
              if (!(!this.app.BROWSER && mycallback != null)) {
                _context7.n = 21;
                break;
              }
              if (this.canModerateStore(tx)) {
                _context7.n = 10;
                break;
              }
              mycallback({
                err: 'Unauthorized access',
                authorized: 0,
                pending: 0,
                results: []
              });
              return _context7.a(2, 1);
            case 10:
              _data = txmsg.data && _typeof(txmsg.data) === 'object' ? txmsg.data : {};
              action = String(_data.action || '').trim().toLowerCase();
              if (!(action !== 'approve' && action !== 'reject')) {
                _context7.n = 11;
                break;
              }
              mycallback({
                err: 'Invalid action',
                results: []
              });
              return _context7.a(2, 1);
            case 11:
              signatures = Array.isArray(_data.signatures) ? _toConsumableArray(new Set(_data.signatures.map(function (sig) {
                return String(sig || '').trim();
              }).filter(Boolean))) : [];
              results = [];
              _iterator = _createForOfIteratorHelper(signatures);
              _context7.p = 12;
              _iterator.s();
            case 13:
              if ((_step = _iterator.n()).done) {
                _context7.n = 16;
                break;
              }
              signature = _step.value;
              _context7.n = 14;
              return this.warehouse.db.moderatePendingListing(signature, action);
            case 14:
              _result = _context7.v;
              results.push({
                signature: signature,
                ok: !!(_result !== null && _result !== void 0 && _result.ok),
                approved: _result === null || _result === void 0 ? void 0 : _result.approved,
                err: (_result === null || _result === void 0 ? void 0 : _result.err) || ''
              });
            case 15:
              _context7.n = 13;
              break;
            case 16:
              _context7.n = 18;
              break;
            case 17:
              _context7.p = 17;
              _t3 = _context7.v;
              _iterator.e(_t3);
            case 18:
              _context7.p = 18;
              _iterator.f();
              return _context7.f(18);
            case 19:
              _context7.n = 20;
              return this.warehouse.db.countPendingModerationListings();
            case 20:
              _pending2 = _context7.v;
              mycallback({
                authorized: 1,
                pending: _pending2,
                results: results
              });
              return _context7.a(2, 1);
            case 21:
              if (!((txmsg === null || txmsg === void 0 ? void 0 : txmsg.request) === 'load-listings')) {
                _context7.n = 26;
                break;
              }
              if (!(!this.app.BROWSER && mycallback != null)) {
                _context7.n = 26;
                break;
              }
              _data2 = txmsg.data && _typeof(txmsg.data) === 'object' ? txmsg.data : {};
              public_key = String(_data2.public_key || '').trim();
              if (!public_key) {
                _context7.n = 23;
                break;
              }
              _context7.n = 22;
              return this.warehouse.returnActiveListingsPage({
                sellers: [public_key],
                category: _data2.category || '',
                offset: normalizeOffset(_data2.offset),
                page_size: normalizePageSize(_data2.page_size),
                status: _data2.status
              });
            case 22:
              _result2 = _context7.v;
              _context7.n = 25;
              break;
            case 23:
              _context7.n = 24;
              return this.warehouse.returnMarketplaceListingsPage({
                whitelist_sellers: this.returnMarketplaceWhitelist(),
                category: _data2.category || '',
                offset: normalizeOffset(_data2.offset),
                page_size: normalizePageSize(_data2.page_size)
              });
            case 24:
              _result2 = _context7.v;
            case 25:
              listings = _result2.listings.map(function (summary) {
                return summary.serialize();
              });
              mycallback({
                listings: listings,
                public_key: public_key,
                category: _result2.category,
                pagination: _result2.pagination
              });
              return _context7.a(2, 1);
            case 26:
              if (!((txmsg === null || txmsg === void 0 ? void 0 : txmsg.request) === 'load-web3-proceeds')) {
                _context7.n = 34;
                break;
              }
              if (!(!this.app.BROWSER && mycallback != null)) {
                _context7.n = 34;
                break;
              }
              seller = String(((_tx$from = tx.from) === null || _tx$from === void 0 || (_tx$from = _tx$from[0]) === null || _tx$from === void 0 ? void 0 : _tx$from.publicKey) || '').trim();
              latestBlockId = null;
              _context7.p = 27;
              _t4 = Number;
              _context7.n = 28;
              return (_this$app$blockchain = this.app.blockchain) === null || _this$app$blockchain === void 0 || (_this$app$blockchain$ = _this$app$blockchain.getLatestBlockId) === null || _this$app$blockchain$ === void 0 ? void 0 : _this$app$blockchain$.call(_this$app$blockchain);
            case 28:
              latestBlockId = _t4(_context7.v);
              _context7.n = 30;
              break;
            case 29:
              _context7.p = 29;
              _t5 = _context7.v;
              latestBlockId = null;
            case 30:
              if (!seller) {
                _context7.n = 32;
                break;
              }
              _context7.n = 31;
              return this.warehouse.db.returnWeb3WithdrawalBalances(seller, latestBlockId, this.web3_withdrawal_blocks);
            case 31:
              _t6 = _context7.v;
              _context7.n = 33;
              break;
            case 32:
              _t6 = {
                pending: {},
                eligible: {}
              };
            case 33:
              balances = _t6;
              mycallback(balances);
              return _context7.a(2, 1);
            case 34:
              if (!((txmsg === null || txmsg === void 0 ? void 0 : txmsg.request) === 'store-withdrawal-quote')) {
                _context7.n = 36;
                break;
              }
              if (!(!this.app.BROWSER && mycallback != null)) {
                _context7.n = 36;
                break;
              }
              _seller = String(((_tx$from2 = tx.from) === null || _tx$from2 === void 0 || (_tx$from2 = _tx$from2[0]) === null || _tx$from2 === void 0 ? void 0 : _tx$from2.publicKey) || '').trim();
              _data3 = txmsg.data && _typeof(txmsg.data) === 'object' ? txmsg.data : {};
              _context7.n = 35;
              return this.withdrawals.createQuote({
                seller: _seller,
                ticker: _data3.ticker,
                withdrawalAddress: _data3.withdrawal_address
              });
            case 35:
              quote = _context7.v;
              mycallback(quote);
              return _context7.a(2, 1);
            case 36:
              if (!((txmsg === null || txmsg === void 0 ? void 0 : txmsg.request) === 'store-withdrawal')) {
                _context7.n = 38;
                break;
              }
              if (!(!this.app.BROWSER && mycallback != null)) {
                _context7.n = 38;
                break;
              }
              _context7.n = 37;
              return this.withdrawals.acceptSubmittedTransaction(tx);
            case 37:
              _result3 = _context7.v;
              mycallback(_result3);
              return _context7.a(2, 1);
            case 38:
              if (!((txmsg === null || txmsg === void 0 ? void 0 : txmsg.request) === 'submit-listing')) {
                _context7.n = 46;
                break;
              }
              if (!(!this.app.BROWSER && mycallback != null)) {
                _context7.n = 46;
                break;
              }
              _data4 = txmsg.data && _typeof(txmsg.data) === 'object' ? txmsg.data : {};
              _signature = String(_data4.signature || '').trim();
              requester = String(((_tx$from3 = tx.from) === null || _tx$from3 === void 0 || (_tx$from3 = _tx$from3[0]) === null || _tx$from3 === void 0 ? void 0 : _tx$from3.publicKey) || '').trim();
              if (_signature) {
                _context7.n = 39;
                break;
              }
              mycallback({
                err: 'Listing signature required'
              });
              return _context7.a(2, 1);
            case 39:
              if (requester) {
                _context7.n = 40;
                break;
              }
              mycallback({
                err: 'Unauthorized'
              });
              return _context7.a(2, 1);
            case 40:
              _context7.n = 41;
              return this.warehouse.db.returnCanonicalListingBySignature(_signature);
            case 41:
              row = _context7.v;
              if (row) {
                _context7.n = 42;
                break;
              }
              mycallback({
                err: 'Listing not found'
              });
              return _context7.a(2, 1);
            case 42:
              if (!(String(row.seller || '') !== requester)) {
                _context7.n = 43;
                break;
              }
              mycallback({
                err: 'Unauthorized'
              });
              return _context7.a(2, 1);
            case 43:
              _context7.n = 44;
              return this.warehouse.db.submitListingForMainStore(_signature);
            case 44:
              _result4 = _context7.v;
              if (_result4 !== null && _result4 !== void 0 && _result4.ok) {
                _context7.n = 45;
                break;
              }
              mycallback({
                err: (_result4 === null || _result4 === void 0 ? void 0 : _result4.err) || 'Unable to submit listing'
              });
              return _context7.a(2, 1);
            case 45:
              mycallback({
                ok: true,
                signature: _signature,
                approved: _result4.approved,
                unchanged: !!_result4.unchanged
              });
              return _context7.a(2, 1);
            case 46:
              if (!((txmsg === null || txmsg === void 0 ? void 0 : txmsg.request) === 'review-listing')) {
                _context7.n = 54;
                break;
              }
              if (!(!this.app.BROWSER && mycallback != null)) {
                _context7.n = 54;
                break;
              }
              if (this.canModerateStore(tx)) {
                _context7.n = 47;
                break;
              }
              mycallback({
                err: 'Unauthorized access'
              });
              return _context7.a(2, 1);
            case 47:
              _data5 = txmsg.data && _typeof(txmsg.data) === 'object' ? txmsg.data : {};
              _signature2 = String(_data5.signature || '').trim();
              _action = String(_data5.action || '').trim().toLowerCase();
              if (_signature2) {
                _context7.n = 48;
                break;
              }
              mycallback({
                err: 'Listing signature required'
              });
              return _context7.a(2, 1);
            case 48:
              if (!(_action !== 'approve' && _action !== 'unapprove')) {
                _context7.n = 49;
                break;
              }
              mycallback({
                err: 'Invalid action'
              });
              return _context7.a(2, 1);
            case 49:
              _context7.n = 50;
              return this.warehouse.db.returnCanonicalListingBySignature(_signature2);
            case 50:
              _row = _context7.v;
              if (_row) {
                _context7.n = 51;
                break;
              }
              mycallback({
                err: 'Listing not found'
              });
              return _context7.a(2, 1);
            case 51:
              approved = _action === 'approve';
              _context7.n = 52;
              return this.warehouse.db.setListingApproved(_signature2, approved);
            case 52:
              ok = _context7.v;
              if (ok) {
                _context7.n = 53;
                break;
              }
              mycallback({
                err: 'Unable to update listing'
              });
              return _context7.a(2, 1);
            case 53:
              mycallback({
                signature: _signature2,
                approved: approved ? 1 : 0
              });
              return _context7.a(2, 1);
            case 54:
              if (!((txmsg === null || txmsg === void 0 ? void 0 : txmsg.request) === 'load-listing' && (txmsg === null || txmsg === void 0 || (_txmsg$data = txmsg.data) === null || _txmsg$data === void 0 ? void 0 : _txmsg$data.module) === this.name)) {
                _context7.n = 66;
                break;
              }
              if (!(!this.app.BROWSER && mycallback != null)) {
                _context7.n = 66;
                break;
              }
              _context7.p = 55;
              if (!txmsg.data.signature) {
                _context7.n = 57;
                break;
              }
              _context7.n = 56;
              return this.warehouse.db.returnCanonicalListingBySignature(txmsg.data.signature);
            case 56:
              _t7 = _context7.v;
              _context7.n = 61;
              break;
            case 57:
              if (!(txmsg.data.seller && txmsg.data.nft_id)) {
                _context7.n = 59;
                break;
              }
              _context7.n = 58;
              return this.warehouse.db.returnActiveListingsForSeller(txmsg.data.seller, txmsg.data.nft_id);
            case 58:
              _t8 = _context7.v[0];
              _context7.n = 60;
              break;
            case 59:
              _t8 = null;
            case 60:
              _t7 = _t8;
            case 61:
              _row2 = _t7;
              Listing = require('./lib/listing');
              if (!(!_row2 || !new Listing(_row2).isAvailable() || Number(_row2.quantity) <= 0)) {
                _context7.n = 62;
                break;
              }
              mycallback({
                err: 'Listing unavailable'
              });
              return _context7.a(2, 1);
            case 62:
              _context7.n = 63;
              return this.warehouse.summaryFromListingRow(_row2);
            case 63:
              summary = _context7.v;
              mycallback({
                listing: summary.serialize()
              });
              _context7.n = 65;
              break;
            case 64:
              _context7.p = 64;
              _t9 = _context7.v;
              console.error('Store: shared listing lookup failed', _t9);
              mycallback({
                err: 'Unable to load listing'
              });
            case 65:
              return _context7.a(2, 1);
            case 66:
              if (!((txmsg === null || txmsg === void 0 ? void 0 : txmsg.request) === 'load-seller-inventory')) {
                _context7.n = 68;
                break;
              }
              if (!(!this.app.BROWSER && mycallback != null)) {
                _context7.n = 68;
                break;
              }
              _data6 = txmsg.data && _typeof(txmsg.data) === 'object' ? txmsg.data : {};
              _seller2 = String(_data6.seller || '').trim();
              _context7.n = 67;
              return this.warehouse.returnSellerInventory(_seller2);
            case 67:
              _result5 = _context7.v;
              mycallback({
                seller: _result5.seller,
                active: (_result5.active || []).map(function (summary) {
                  return summary.serialize();
                }),
                sold: (_result5.sold || []).map(function (summary) {
                  return summary.serialize();
                })
              });
              return _context7.a(2, 1);
            case 68:
              if (!((txmsg === null || txmsg === void 0 ? void 0 : txmsg.request) === 'load-listing-spend')) {
                _context7.n = 73;
                break;
              }
              if (!(!this.app.BROWSER && mycallback != null)) {
                _context7.n = 73;
                break;
              }
              _data7 = txmsg.data && _typeof(txmsg.data) === 'object' ? txmsg.data : {};
              _signature3 = String(_data7.signature || '').trim();
              _requester = String(((_tx$from4 = tx.from) === null || _tx$from4 === void 0 || (_tx$from4 = _tx$from4[0]) === null || _tx$from4 === void 0 ? void 0 : _tx$from4.publicKey) || '').trim(); // Only the longest-chain inclusion holds slips the chain can still spend.
              if (!_signature3) {
                _context7.n = 70;
                break;
              }
              _context7.n = 69;
              return this.warehouse.db.returnCanonicalListingBySignature(_signature3);
            case 69:
              _t0 = _context7.v;
              _context7.n = 71;
              break;
            case 70:
              _t0 = null;
            case 71:
              _row3 = _t0;
              _Listing = require('./lib/listing');
              listing = _row3 ? new _Listing(_row3) : null;
              if (!(!listing || !listing.isAvailable() || !_requester || listing.seller !== _requester)) {
                _context7.n = 72;
                break;
              }
              mycallback(null);
              return _context7.a(2, 1);
            case 72:
              mycallback({
                signature: listing.signature,
                nft_id: listing.nft_id,
                seller: listing.seller,
                quantity: listing.quantity,
                price: listing.price,
                category: listing.category,
                access_script: listing.access_script,
                access_hash: listing.access_hash,
                p2sh_address: listing.p2sh_address,
                utxo_slip1: listing.utxo_slip1,
                utxo_slip2: listing.utxo_slip2,
                utxo_slip3: listing.utxo_slip3
              });
              return _context7.a(2, 1);
            case 73:
              return _context7.a(2, _superPropGet(Store, "handlePeerTransaction", this, 3)([app, tx, peer, mycallback]));
          }
        }, _callee7, this, [[55, 64], [27, 29], [12, 17, 18, 19]]);
      }));
      function handlePeerTransaction(_x5) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }()
  }, {
    key: "requestStoreModerationState",
    value: function requestStoreModerationState() {
      var _this$app,
        _this4 = this;
      if (!this.app.BROWSER) {
        return;
      }
      var peerKey = this.store_public_key;
      if (!peerKey || !((_this$app = this.app) !== null && _this$app !== void 0 && (_this$app = _this$app.network) !== null && _this$app !== void 0 && _this$app.sendRequestAsTransaction)) {
        return;
      }
      this.app.network.sendRequestAsTransaction('store-moderation', {
        module: 'Store'
      }, function (response) {
        _this4.applyStoreModerationResponse(response);
      }, peerKey, true);
    }
  }, {
    key: "applyStoreModerationResponse",
    value: function applyStoreModerationResponse() {
      var _this$main2, _this$main2$showModer, _this$app$storage, _this$app$storage$sav;
      var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!this.app.BROWSER) {
        return;
      }
      var payload = response && _typeof(response) === 'object' ? response.request === 'store-moderation-response' && response.data && _typeof(response.data) === 'object' ? response.data : response : {};
      var authorized = Number(payload.authorized) === 1 ? 1 : 0;
      var pending = authorized ? Math.max(0, Number(payload.pending) || 0) : 0;
      this.listings_to_moderate = pending;
      (_this$main2 = this.main) === null || _this$main2 === void 0 || (_this$main2 = _this$main2.menu) === null || _this$main2 === void 0 || (_this$main2$showModer = _this$main2.showModeration) === null || _this$main2$showModer === void 0 || _this$main2$showModer.call(_this$main2, this.listings_to_moderate);
      this.app.connection.emit('saito-notification', {
        id: 'store-moderation',
        text: 'There are new listings on the Store to moderate.',
        href: '/store/moderate',
        pending: this.listings_to_moderate
      });
      if (!this.app.options || _typeof(this.app.options) !== 'object') {
        this.app.options = {};
      }
      if (!this.app.options.store || _typeof(this.app.options.store) !== 'object') {
        this.app.options.store = {};
      }
      this.app.options.store.moderator = authorized;
      (_this$app$storage = this.app.storage) === null || _this$app$storage === void 0 || (_this$app$storage$sav = _this$app$storage.saveOptions) === null || _this$app$storage$sav === void 0 || _this$app$storage$sav.call(_this$app$storage);
    }

    /**
     * ModTools seller whitelist used for the main Store catalog.
     */
  }, {
    key: "returnMarketplaceWhitelist",
    value: function returnMarketplaceWhitelist() {
      var modtools = this.app.modules.returnModuleBySlug('modtools');
      return Array.isArray(modtools === null || modtools === void 0 ? void 0 : modtools.whitelisted_publickeys) ? modtools.whitelisted_publickeys.slice() : [];
    }
  }, {
    key: "txIsFromAnyKey",
    value: function txIsFromAnyKey(tx) {
      var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      if (!tx || !Array.isArray(keys) || !keys.length) {
        return false;
      }
      return keys.some(function (key) {
        try {
          return tx.isFrom(key);
        } catch (err) {
          return false;
        }
      });
    }

    /**
     * Node-operator keys in app.options.admin. An empty list authorizes nobody
     * (unlike Admin module's open-if-unconfigured default).
     */
  }, {
    key: "isStoreAdmin",
    value: function isStoreAdmin(tx) {
      var _this$app$options3;
      var admins = Array.isArray((_this$app$options3 = this.app.options) === null || _this$app$options3 === void 0 ? void 0 : _this$app$options3.admin) ? this.app.options.admin : [];
      return this.txIsFromAnyKey(tx, admins);
    }

    /**
     * Listing moderation: node admins, plus anyone on the Store seller whitelist.
     */
  }, {
    key: "canModerateStore",
    value: function canModerateStore(tx) {
      return this.isStoreAdmin(tx) || this.txIsFromAnyKey(tx, this.returnMarketplaceWhitelist());
    }
  }, {
    key: "respondTo",
    value: function respondTo() {
      var _this5 = this;
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var obj = arguments.length > 1 ? arguments[1] : undefined;
      if (type === 'admin-sidebar') {
        if (!this.app.BROWSER) {
          return null;
        }
        return {
          id: this.returnSlug(),
          name: this.name,
          render: function render() {
            if (!_this5.admin_ui) {
              _this5.admin_ui = new StoreAdmin(_this5.app, _this5);
            }
            _this5.admin_ui.render();
          }
        };
      }
      if (type === 'redsquare-profile') {
        var _obj$profile;
        var publicKey = String((obj === null || obj === void 0 ? void 0 : obj.publicKey) || '').trim();
        if (!publicKey) {
          return null;
        }
        var link = String((obj === null || obj === void 0 || (_obj$profile = obj.profile) === null || _obj$profile === void 0 ? void 0 : _obj$profile.store) || '').trim();
        if (!link) {
          var _this$app$modules$ret3, _this$app$modules3;
          var api = (_this$app$modules$ret3 = (_this$app$modules3 = this.app.modules).returnFirstRespondTo) === null || _this$app$modules$ret3 === void 0 ? void 0 : _this$app$modules$ret3.call(_this$app$modules3, 'profile-update');
          if (api && typeof api.get === 'function') {
            try {
              var profile = api.get(publicKey) || {};
              link = String(profile.store || '').trim();
            } catch (err) {
              link = '';
            }
          }
        }
        if (!link) {
          return null;
        }
        return {
          text: 'Store',
          link: link
        };
      }
      if (type === 'user-menu') {
        var _publicKey = String((obj === null || obj === void 0 ? void 0 : obj.publicKey) || '').trim();
        if (!_publicKey) {
          return null;
        }
        return {
          text: _publicKey === this.publicKey ? 'My Store' : 'View Store',
          icon: 'fa-solid fa-store',
          callback: function callback(app, key) {
            navigateWindow(_this5.returnStorefrontPath(key));
          }
        };
      }
      if (type === 'saito-header') {
        if (this.browser_active) {
          return [];
        }
        return [{
          text: 'Store',
          icon: 'fa-solid fa-store',
          rank: 15,
          type: 'navigation',
          navigation: '/store',
          callback: function callback() {
            navigateWindow('/store');
          }
        }];
      }
      if (type === 'saito-create-nft') {
        return {
          title: 'Store Rental NFT',
          "class": ['store-nft-rental'],
          upload_text: 'drag-and-drop image for this rental listing',
          createData: function () {
            var _createData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(modfile) {
              var metadata,
                image,
                hours,
                duration_ms,
                _args8 = arguments;
              return _regenerator().w(function (_context8) {
                while (1) switch (_context8.n) {
                  case 0:
                    metadata = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : {};
                    image = metadata.image || (modfile && String(modfile).startsWith('data:image') ? modfile : '') || '';
                    if (image) {
                      _context8.n = 1;
                      break;
                    }
                    salert('Attach an image for the Rental NFT');
                    return _context8.a(2, false);
                  case 1:
                    if (metadata.file_id) {
                      _context8.n = 2;
                      break;
                    }
                    salert('Missing Vault file_id for this rental NFT');
                    return _context8.a(2, false);
                  case 2:
                    if (metadata.link) {
                      _context8.n = 3;
                      break;
                    }
                    salert('Missing Vault link for this rental NFT');
                    return _context8.a(2, false);
                  case 3:
                    if (metadata.filename) {
                      _context8.n = 4;
                      break;
                    }
                    salert('Missing Vault filename for this rental NFT');
                    return _context8.a(2, false);
                  case 4:
                    if (metadata.file_access_script) {
                      _context8.n = 5;
                      break;
                    }
                    salert('Missing Vault file_access_script for this rental NFT');
                    return _context8.a(2, false);
                  case 5:
                    if (metadata.nft_type) {
                      _context8.n = 6;
                      break;
                    }
                    salert('Missing source nft_type for this rental NFT');
                    return _context8.a(2, false);
                  case 6:
                    hours = parseInt(metadata.duration_hours, 10);
                    if (!Number.isFinite(hours) || hours < 1) {
                      hours = 1;
                    }
                    if (hours > 24) {
                      hours = 24;
                    }
                    duration_ms = Number(metadata.duration_ms) > 0 ? Number(metadata.duration_ms) : hours * 60 * 60 * 1000; // Vault protected-file fields stay on txmsg.data under established names.
                    // Slip/NFT type remains store-nft-rental; data.nft_type is the source type.
                    return _context8.a(2, {
                      module: 'Store',
                      link: String(metadata.link),
                      nft_type: String(metadata.nft_type),
                      filename: String(metadata.filename),
                      file_id: String(metadata.file_id),
                      file_access_script: typeof metadata.file_access_script === 'string' ? metadata.file_access_script : JSON.stringify(metadata.file_access_script),
                      duration_hours: hours,
                      duration_ms: duration_ms,
                      rights: metadata.rights || 'all',
                      image: image
                    });
                }
              }, _callee8);
            }));
            function createData(_x6) {
              return _createData.apply(this, arguments);
            }
            return createData;
          }()
        };
      }
      if (type === 'saito-sell-nft') {
        return {
          render: function render() {
            var _this5$main;
            var defaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (_this5.app.BROWSER && typeof _this5.attachStyleSheets === 'function') {
              _this5.attachStyleSheets();
            }
            if ((_this5$main = _this5.main) !== null && _this5$main !== void 0 && _this5$main.openSell) {
              _this5.main.openSell(defaults);
              return;
            }
            if (!_this5.listing_overlay) {
              var NftPickerOverlay = require('./lib/ui/overlays/nft-picker');
              var ListingDetailOverlay = require('./lib/ui/overlays/listing-detail');
              var RentalListingOverlay = require('./lib/ui/overlays/rental-listing');
              var _require4 = require('./lib/categories'),
                normalizeListingMode = _require4.normalizeListingMode;
              var nft_picker = new NftPickerOverlay(_this5.app, _this5);
              var listing_detail = new ListingDetailOverlay(_this5.app, _this5);
              var rental_listing = new RentalListingOverlay(_this5.app, _this5);
              nft_picker.onSelect = function (nft, defs) {
                if (normalizeListingMode(defs === null || defs === void 0 ? void 0 : defs.listing_mode) === 'rent') {
                  rental_listing.render({
                    source_nft: nft,
                    defaults: defs
                  });
                  return;
                }
                listing_detail.render({
                  mode: 'edit',
                  nft: nft,
                  defaults: defs
                });
              };
              listing_detail.onBack = function (defs) {
                nft_picker.render(defs || {});
              };
              rental_listing.onBack = function (defs) {
                nft_picker.render(_objectSpread(_objectSpread({}, defs || {}), {}, {
                  listing_mode: 'rent'
                }));
              };
              _this5.listing_overlay = {
                render: function render() {
                  var defs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                  var next = _objectSpread(_objectSpread({}, defs), {}, {
                    listing_mode: normalizeListingMode(defs.listing_mode)
                  });
                  if (next !== null && next !== void 0 && next.nft) {
                    if (next.listing_mode === 'rent') {
                      rental_listing.render({
                        source_nft: next.nft,
                        defaults: next
                      });
                    } else {
                      listing_detail.render({
                        mode: 'edit',
                        nft: next.nft,
                        defaults: next
                      });
                    }
                  } else {
                    nft_picker.render(next);
                  }
                }
              };
            }
            _this5.listing_overlay.render(defaults);
          }
        };
      }

      //
      // store-nft-rental transfers: mutate the EXISTING Bound NFT transfer by
      // appending a hop on tx.msg.data.path (Stack pattern). Default delegated: 0;
      // Store listing passes { delegated: true }. Does not create/sign/propagate.
      //
      if (type === 'saito-nft-transfer') {
        var this_mod = this;
        return {
          "class": ['store-nft-rental'],
          onTransfer: function () {
            var _onTransfer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
              var nft,
                tx,
                receiver,
                data,
                expires_at,
                _nft$tx2,
                _nft$tx2$returnMessag,
                nft_data,
                duration_ms,
                file_id,
                _nft$tx3,
                _nft$tx3$returnMessag,
                _nft_data,
                _parsed$data,
                parsed,
                delegated,
                value_obj,
                value_b64,
                binding_hash,
                canonical_string,
                hash_digest,
                privatekey,
                sig,
                _args9 = arguments;
              return _regenerator().w(function (_context9) {
                while (1) switch (_context9.n) {
                  case 0:
                    nft = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : null;
                    tx = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : null;
                    receiver = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : '';
                    data = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : {};
                    if (tx) {
                      _context9.n = 1;
                      break;
                    }
                    return _context9.a(2, tx);
                  case 1:
                    if (!tx.msg) {
                      tx.msg = {};
                    }
                    if (!tx.msg.data || _typeof(tx.msg.data) !== 'object') {
                      tx.msg.data = {};
                    }
                    if (!Array.isArray(tx.msg.data.path)) {
                      tx.msg.data.path = [];
                    }
                    receiver = String(receiver || '').trim();
                    if (receiver) {
                      _context9.n = 2;
                      break;
                    }
                    return _context9.a(2, tx);
                  case 2:
                    expires_at = null;
                    if (tx.msg.data.expires_at != null && tx.msg.data.expires_at !== '') {
                      expires_at = Number(tx.msg.data.expires_at);
                    } else {
                      nft_data = (nft === null || nft === void 0 || (_nft$tx2 = nft.tx) === null || _nft$tx2 === void 0 || (_nft$tx2$returnMessag = _nft$tx2.returnMessage) === null || _nft$tx2$returnMessag === void 0 || (_nft$tx2$returnMessag = _nft$tx2$returnMessag.call(_nft$tx2)) === null || _nft$tx2$returnMessag === void 0 ? void 0 : _nft$tx2$returnMessag.data) || (nft === null || nft === void 0 ? void 0 : nft.data) || {};
                      duration_ms = Number(nft_data.duration_ms || tx.msg.data.duration_ms);
                      if (Number.isFinite(duration_ms) && duration_ms > 0) {
                        expires_at = Date.now() + duration_ms;
                      }
                    }
                    if (!(expires_at == null || !Number.isFinite(expires_at))) {
                      _context9.n = 3;
                      break;
                    }
                    throw new Error('store-nft-rental transfer requires expires_at or duration_ms');
                  case 3:
                    tx.msg.data.expires_at = expires_at;
                    file_id = tx.msg.data.file_id || null;
                    if (!file_id) {
                      _nft_data = (nft === null || nft === void 0 || (_nft$tx3 = nft.tx) === null || _nft$tx3 === void 0 || (_nft$tx3$returnMessag = _nft$tx3.returnMessage) === null || _nft$tx3$returnMessag === void 0 || (_nft$tx3$returnMessag = _nft$tx3$returnMessag.call(_nft$tx3)) === null || _nft$tx3$returnMessag === void 0 ? void 0 : _nft$tx3$returnMessag.data) || (nft === null || nft === void 0 ? void 0 : nft.data) || null;
                      if (_nft_data !== null && _nft_data !== void 0 && _nft_data.file_id) {
                        file_id = _nft_data.file_id;
                      }
                    }
                    if (!file_id && nft !== null && nft !== void 0 && nft.json) {
                      try {
                        parsed = typeof nft.json === 'string' ? JSON.parse(nft.json) : nft.json;
                        file_id = (parsed === null || parsed === void 0 ? void 0 : parsed.file_id) || (parsed === null || parsed === void 0 || (_parsed$data = parsed.data) === null || _parsed$data === void 0 ? void 0 : _parsed$data.file_id) || null;
                      } catch (err) {
                        file_id = null;
                      }
                    }
                    if (file_id) {
                      _context9.n = 4;
                      break;
                    }
                    throw new Error('store-nft-rental transfer requires file_id');
                  case 4:
                    file_id = String(file_id);
                    tx.msg.data.file_id = file_id;

                    // Transfer context only — never infer from NFT type.
                    delegated = data && data.delegated === true ? 1 : 0;
                    value_obj = {
                      timestamp: Date.now(),
                      file_id: file_id,
                      expires_at: Number(expires_at),
                      delegated: delegated
                    };
                    value_b64 = Buffer.from(JSON.stringify(value_obj)).toString('base64');
                    binding_hash = '';
                    canonical_string = "".concat(receiver, "|").concat(value_b64, "|").concat(binding_hash);
                    hash_digest = this_mod.app.crypto.hash(canonical_string);
                    _context9.n = 5;
                    return this_mod.app.wallet.getPrivateKey();
                  case 5:
                    privatekey = _context9.v;
                    sig = this_mod.app.crypto.signMessage(hash_digest, privatekey);
                    tx.msg.data.path.push({
                      to: receiver,
                      value: value_b64,
                      sig: sig
                    });
                    return _context9.a(2, tx);
                }
              }, _callee9);
            }));
            function onTransfer() {
              return _onTransfer.apply(this, arguments);
            }
            return onTransfer;
          }()
        };
      }
      return _superPropGet(Store, "respondTo", this, 3)([type, obj]);
    }

    /**
     * Path for a public creator storefront: /store/<publickey>
     */
  }, {
    key: "returnStorefrontPath",
    value: function returnStorefrontPath() {
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var key = String(publicKey || '').trim();
      if (!key) {
        return '/' + encodeURI(this.returnSlug());
      }
      return "/".concat(encodeURI(this.returnSlug()), "/").concat(encodeURIComponent(key));
    }

    /**
     * Path for seller administration: /store/<publickey>/admin
     */
  }, {
    key: "returnAdminPath",
    value: function returnAdminPath() {
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var base = this.returnStorefrontPath(publicKey);
      if (!String(publicKey || '').trim()) {
        return base;
      }
      return "".concat(base, "/admin");
    }

    /**
     * Absolute shareable URL for a public creator storefront.
     */
  }, {
    key: "returnStorefrontUrl",
    value: function returnStorefrontUrl() {
      var _window$location;
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var path = this.returnStorefrontPath(publicKey);
      if (this.app.BROWSER && typeof window !== 'undefined' && (_window$location = window.location) !== null && _window$location !== void 0 && _window$location.origin) {
        return "".concat(window.location.origin).concat(path);
      }
      return path;
    }

    /**
     * Absolute URL for seller administration.
     */
  }, {
    key: "returnAdminUrl",
    value: function returnAdminUrl() {
      var _window$location2;
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var path = this.returnAdminPath(publicKey);
      if (this.app.BROWSER && typeof window !== 'undefined' && (_window$location2 = window.location) !== null && _window$location2 !== void 0 && _window$location2.origin) {
        return "".concat(window.location.origin).concat(path);
      }
      return path;
    }
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var route;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              if (!(!this.browser_active || !this.main)) {
                _context0.n = 1;
                break;
              }
              return _context0.a(2);
            case 1:
              _context0.n = 2;
              return _superPropGet(Store, "render", this, 3)([]);
            case 2:
              route = this.returnStoreRouteFromPath();
              if (!route.moderate) {
                _context0.n = 4;
                break;
              }
              _context0.n = 3;
              return this.main.openModerate({
                updateUrl: false
              });
            case 3:
              return _context0.a(2);
            case 4:
              if (!route.publicKey) {
                _context0.n = 6;
                break;
              }
              _context0.n = 5;
              return this.main.openStorefront(route.publicKey, {
                updateUrl: false,
                admin: route.admin,
                category: route.category
              });
            case 5:
              return _context0.a(2);
            case 6:
              if (route.category) {
                this.main.manager.browse.category = route.category;
                this.main.menu.setActive(categoryViewKey(route.category));
              }
            case 7:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
    /**
     * Parse storefront, admin, moderation, and current or legacy item URLs.
     * Optional ?type=<nft-type> is mapped to a marketplace/storefront category.
     * Item routes also include nft_id, or signature for legacy links.
     */
  }, {
    key: "returnStoreRouteFromPath",
    value: function returnStoreRouteFromPath() {
      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var empty = {
        publicKey: '',
        admin: false,
        moderate: false,
        category: ''
      };
      var currentLocation = location || (this.app.BROWSER && typeof window !== 'undefined' ? window.location : null);
      if (!currentLocation) {
        return empty;
      }
      var type = new URLSearchParams(currentLocation.search || '').get('type') || '';
      var category = type ? mapNFTTypeToCategory(type) : '';
      var pathname = currentLocation.pathname || '';
      var slug = '/' + this.slug;
      if (pathname !== slug && !pathname.startsWith("".concat(slug, "/"))) {
        return _objectSpread(_objectSpread({}, empty), {}, {
          category: category
        });
      }
      var segments = pathname.substring(slug.length).split('/').filter(function (seg) {
        return seg.length > 0;
      });
      if (segments.length === 1 && segments[0] === 'moderate') {
        return {
          publicKey: '',
          admin: false,
          moderate: true,
          category: category
        };
      }
      if (segments.length === 1 && segments[0] !== 'cache') {
        return {
          publicKey: decodeURIComponent(segments[0]),
          admin: false,
          moderate: false,
          category: category
        };
      }
      if (segments.length === 2 && segments[0] === 'listing') {
        return _objectSpread(_objectSpread({}, empty), {}, {
          signature: decodeURIComponent(segments[1]),
          category: category
        });
      }
      if (segments.length === 2 && segments[0] !== 'cache' && segments[1] === 'admin') {
        return {
          publicKey: decodeURIComponent(segments[0]),
          admin: true,
          moderate: false,
          category: category
        };
      }
      if (segments.length === 2 && !['cache', 's', 'moderate'].includes(segments[0])) {
        return _objectSpread(_objectSpread({}, empty), {}, {
          publicKey: decodeURIComponent(segments[0]),
          nft_id: decodeURIComponent(segments[1]),
          category: category
        });
      }
      return {
        publicKey: '',
        admin: false,
        moderate: false,
        category: category
      };
    }

    /**
     * Parse /store/<publickey> (or admin) public key from the current browser path.
     */
  }, {
    key: "returnStorefrontKeyFromPath",
    value: function returnStorefrontKeyFromPath() {
      return this.returnStoreRouteFromPath().publicKey;
    }
  }, {
    key: "shouldAffixCallbackToModule",
    value: function shouldAffixCallbackToModule(modname) {
      var _this$transaction_mon;
      var tx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (modname === this.name) {
        return 1;
      }
      // Allow the shared transaction monitor to receive confirmations it is watching.
      if ((_this$transaction_mon = this.transaction_monitor) !== null && _this$transaction_mon !== void 0 && _this$transaction_mon.tx && tx !== null && tx !== void 0 && tx.signature && tx.signature === this.transaction_monitor.tx.signature) {
        return 1;
      }
      return 0;
    }
  }, {
    key: "onConfirmation",
    value: function () {
      var _onConfirmation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(blk, tx) {
        var conf,
          txmsg,
          _args1 = arguments,
          _t1,
          _t10;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              conf = _args1.length > 2 && _args1[2] !== undefined ? _args1[2] : 0;
              if (!(Number(conf) !== 0)) {
                _context1.n = 1;
                break;
              }
              return _context1.a(2);
            case 1:
              txmsg = tx.returnMessage();
              if (!(txmsg.module !== 'Store')) {
                _context1.n = 2;
                break;
              }
              return _context1.a(2);
            case 2:
              _t1 = txmsg.request;
              _context1.n = _t1 === 'list-asset' ? 3 : _t1 === 'delist-asset' ? 5 : _t1 === 'purchase-asset' ? 7 : _t1 === 'order-refund' ? 9 : 14;
              break;
            case 3:
              this.app.connection.emit('store-list-asset', {
                blk: blk,
                tx: tx,
                conf: conf
              });
              console.log('Store: onConfirmation list-asset conf=0', tx.signature);
              _context1.n = 4;
              return this.receiveListAssetTransaction(blk, tx);
            case 4:
              return _context1.a(3, 15);
            case 5:
              console.log('Store: onConfirmation delist-asset conf=0', tx.signature);
              _context1.n = 6;
              return this.receiveDelistAssetTransaction(blk, tx);
            case 6:
              return _context1.a(3, 15);
            case 7:
              this.app.connection.emit('store-purchase-asset', {
                blk: blk,
                tx: tx,
                conf: conf
              });
              console.log('Store: onConfirmation purchase-asset conf=0', tx.signature);
              _context1.n = 8;
              return this.receivePurchaseAssetTransaction(blk, tx);
            case 8:
              return _context1.a(3, 15);
            case 9:
              this.app.connection.emit('store-order-refund', {
                blk: blk,
                tx: tx,
                conf: conf
              });
              console.log('Store: onConfirmation order-refund conf=0', tx.signature);
              if (this.app.BROWSER) {
                _context1.n = 13;
                break;
              }
              _context1.p = 10;
              _context1.n = 11;
              return this.warehouse.refunds.observeInclusion(blk, tx);
            case 11:
              _context1.n = 13;
              break;
            case 12:
              _context1.p = 12;
              _t10 = _context1.v;
              console.error('Store: refund inclusion was not recorded', {
                refund_tx_sig: tx.signature,
                error: (_t10 === null || _t10 === void 0 ? void 0 : _t10.message) || String(_t10)
              });
            case 13:
              if (this.app.BROWSER && typeof siteMessage === 'function') {
                siteMessage('Refund Issued: order could not be processed.', 5000);
              }
              return _context1.a(3, 15);
            case 14:
              return _context1.a(3, 15);
            case 15:
              return _context1.a(2);
          }
        }, _callee1, this, [[10, 12]]);
      }));
      function onConfirmation(_x7, _x8) {
        return _onConfirmation.apply(this, arguments);
      }
      return onConfirmation;
    }()
  }, {
    key: "onNewBlock",
    value: function () {
      var _onNewBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(blk, lc) {
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              if (!this.app.BROWSER) {
                _context10.n = 1;
                break;
              }
              this.app.connection.emit('store-new-block', {
                blk: blk,
                lc: lc
              });
              return _context10.a(2);
            case 1:
              _context10.n = 2;
              return this.warehouse.onNewBlock(blk, lc);
            case 2:
              return _context10.a(2);
          }
        }, _callee10, this);
      }));
      function onNewBlock(_x9, _x0) {
        return _onNewBlock.apply(this, arguments);
      }
      return onNewBlock;
    }()
  }, {
    key: "onChainReorganization",
    value: function () {
      var _onChainReorganization = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(block_id, block_hash, lc) {
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              if (!this.app.BROWSER) {
                _context11.n = 1;
                break;
              }
              return _context11.a(2);
            case 1:
              _context11.n = 2;
              return this.warehouse.onChainReorganization(block_id, block_hash, lc);
            case 2:
              return _context11.a(2);
          }
        }, _callee11, this);
      }));
      function onChainReorganization(_x1, _x10, _x11) {
        return _onChainReorganization.apply(this, arguments);
      }
      return onChainReorganization;
    }()
  }, {
    key: "returnShortLinkSocial",
    value: function () {
      var _returnShortLinkSocial = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(row, req) {
        var _this$image_cache$sum;
        var origin, target, route, listing, summary, image, _t11, _t12;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              origin = "".concat(req.protocol, "://").concat(req.get('host'));
              target = new URL(row.link, origin);
              if (!(target.origin !== origin)) {
                _context12.n = 1;
                break;
              }
              return _context12.a(2, null);
            case 1:
              route = this.returnStoreRouteFromPath(target);
              if (!route.signature) {
                _context12.n = 3;
                break;
              }
              _context12.n = 2;
              return this.warehouse.db.returnCanonicalListingBySignature(route.signature);
            case 2:
              _t11 = _context12.v;
              _context12.n = 7;
              break;
            case 3:
              if (!(route.publicKey && route.nft_id)) {
                _context12.n = 5;
                break;
              }
              _context12.n = 4;
              return this.warehouse.db.returnActiveListingsForSeller(route.publicKey, route.nft_id);
            case 4:
              _t12 = _context12.v[0];
              _context12.n = 6;
              break;
            case 5:
              _t12 = null;
            case 6:
              _t11 = _t12;
            case 7:
              listing = _t11;
              if (listing) {
                _context12.n = 8;
                break;
              }
              return _context12.a(2, null);
            case 8:
              _context12.n = 9;
              return this.warehouse.summaryFromListingRow(listing);
            case 9:
              summary = _context12.v;
              image = '/store/img/store.png';
              if ((_this$image_cache$sum = this.image_cache[summary.nft_id]) !== null && _this$image_cache$sum !== void 0 && _this$image_cache$sum.startsWith('data:image/')) {
                image = summary.returnCacheImageUrl();
              } else if (/^(https?:\/\/|\/)/i.test(summary.image || '')) {
                image = summary.image;
              }
              return _context12.a(2, _objectSpread(_objectSpread({}, this.social), {}, {
                title: summary.returnTitle(),
                description: [summary.returnPrice(), summary.returnDescription()].filter(Boolean).join(' — '),
                url: "".concat(origin).concat(target.pathname),
                image: new URL(image, origin).href
              }));
          }
        }, _callee12, this);
      }));
      function returnShortLinkSocial(_x12, _x13) {
        return _returnShortLinkSocial.apply(this, arguments);
      }
      return returnShortLinkSocial;
    }()
  }, {
    key: "webServer",
    value: function webServer(app, expressapp, express) {
      var alternative_slug = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var webdir = "".concat(__dirname, "/../../mods/").concat(this.dirname, "/web");
      var uri = alternative_slug || '/' + encodeURI(this.returnSlug());
      var self = this;
      var sendStoreHtml = /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(req, res) {
          var origin, social, listingSocial, html, _t13;
          return _regenerator().w(function (_context13) {
            while (1) switch (_context13.p = _context13.n) {
              case 0:
                origin = "".concat(req.protocol, "://").concat(req.get('host'));
                social = _objectSpread(_objectSpread({}, self.social), {}, {
                  url: "".concat(origin).concat(uri),
                  image: "".concat(origin).concat(uri, "/img/store.png")
                });
                if (!(req.params.signature || req.params.nft_id)) {
                  _context13.n = 4;
                  break;
                }
                _context13.p = 1;
                _context13.n = 2;
                return self.returnShortLinkSocial({
                  link: req.params.signature ? "/".concat(self.returnSlug(), "/listing/").concat(encodeURIComponent(req.params.signature)) : "/".concat(self.returnSlug(), "/").concat(encodeURIComponent(req.params.publickey), "/").concat(encodeURIComponent(req.params.nft_id))
                }, req);
              case 2:
                listingSocial = _context13.v;
                if (listingSocial) {
                  social = listingSocial;
                } else {
                  res.status(404);
                }
                _context13.n = 4;
                break;
              case 3:
                _context13.p = 3;
                _t13 = _context13.v;
                console.error('Store: listing metadata lookup failed', _t13);
                res.status(500);
              case 4:
                html = index(app, self, app.build_number, social);
                res.setHeader('Content-type', 'text/html');
                res.charset = 'UTF-8';
                return _context13.a(2, res.send(html));
            }
          }, _callee13, null, [[1, 3]]);
        }));
        return function sendStoreHtml(_x14, _x15) {
          return _ref3.apply(this, arguments);
        };
      }();
      expressapp.get("".concat(uri, "/cache/:nft_id.img"), function (req, res) {
        var nft_id = decodeURIComponent(String(req.params.nft_id || ''));
        if (!nft_id) {
          return res.status(404).end();
        }
        return serveCachedImageResponse(self, res, nft_id);
      });
      expressapp.use(uri, express["static"](webdir));

      // /store — main browse shell
      expressapp.get(uri, sendStoreHtml);
      expressapp.get("".concat(uri, "/listing/:signature"), sendStoreHtml);

      // /store/moderate — marketplace moderation (must precede /:publickey)
      expressapp.get("".concat(uri, "/moderate"), sendStoreHtml);

      // /store/<publickey>/admin — seller administration shell (client routes after load)
      expressapp.get("".concat(uri, "/:publickey/admin"), sendStoreHtml);
      expressapp.get("".concat(uri, "/:publickey/:nft_id"), sendStoreHtml);

      // /store/<publickey> — public creator storefront shell (client routes after load)
      expressapp.get("".concat(uri, "/:publickey"), sendStoreHtml);
    }
  }]);
}(ModTemplate);
module.exports = Store;